import React from 'react';

const Blog4 = () => {
    return (
        <div className="main-wrapper">
            <div className="container">
                <div className="blog_details">
                    <div className="post_img">
                        <img src="images/blog/details.png" alt="blog" />
                    </div>
                    <div className="blog_details_inner">
                        <div className="post_content">
                            <div className="details_post_header">
                                <div className="calendar">August 29, 2022</div>
                                <h3 className="post_title">How to start your own food Blog</h3>
                            </div>
                            <div className="fulltext first_para">
                                <p>A new day come with new hope, new thoughts and new experience. In one life its not easy to always find the right insight in right time. So People often live their whole life without knowing what the actually wanted to be. On the other hand know ing that what he then wanted & failed to find the right path to make those dream true.sed quia consequuntur magni dolores eos qui ratione.
                                    Quis autem vel eum. At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium volup
                                    tatum deleniti atque corrupti quos dolores et quas molestias excepturi.Smilique sunt in culpiqui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harumquid
                                    em rerum facilis est et expedita distinctio. Nam libero tempore cum soluta nobis.
                                </p>
                                <blockquote className="post_quote">
                                    <div className="blockquote_inner">"Doneco quam felis, ultricies nec, pellentesque preti um quis,sem consequat massa quis enim.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit"</div>
                                    <h6>Christopher Nil, New York</h6>
                                </blockquote>

                                <p>
                                    Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eosratione volptatem
                                    sequi nesciunt. Neque porro quisquam est qui dolorem ipsum quia dolor sit amet consectetur, adipisci
                                    velit tempor lorem ipsum dolor. Lorem ipsum dolor sit amet, consectetur.
                                </p>
                                <p>Smilique sunt in culpiqui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harumquid
                                    em rerum facilis est et expedita distinctio. Nam libero tempore cum soluta nobis est eligendioptio cum
                                    que nihil impedit quo minus quod maxime placeat facere possimu.Nemo enim ipsam voluptatem quia
                                    voluptas sit aspernatur aut odit aut fugit, sed quia corporisiex.
                                </p>
                            </div>
                            <div className="video_post">
                                <div className="ytube_video">
                                    <iframe id="ytvideo" src="https://www.youtube.com/embed/fEErySYqItI" allow="autoplay;" allowfullscreen></iframe>
                                    <div className="post_content">
                                        <div className="ytplay_btn"><img src="images/play_btn.png" alt="" /></div>
                                        <img src="images/blog/video_bg.jpg" alt="blog" />
                                    </div>
                                </div>
                            </div>
                            <div className="fulltext">
                                <p>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam, quis nostrum exercitationem mo
                                    sequatu autem vel eum iure veniam quis nostrum exercitationm aleisequatur? Smilique sunt in culpiqui officia deserunt mollitia animi, id est laborum et dolorum fuga.
                                </p>
                                <p>
                                    Smilique sunt in culpiqui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harumquid
                                    em rerum facilis est et expedita distinctio. Nam libero tempore cum soluta nobis est eligendioptio cum
                                    que nihil impedit quo minus quod maxime placeat facere possimu.Nemo enim ipsam voluptatem quia
                                    voluptas sit aspernatur aut odit aut fugit, sed quia corporisiex.
                                </p>
                                <ul className="point_order">
                                    <li>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam</li>
                                    <li>Sequatu autem vel eum iure veniam quis nostrum exercitationm corporis</li>
                                    <li>Vel eum. At vero eos et accusamus et iusto odio dignissimos ducimus</li>
                                    <li>Tatum deleniti atque corrupti quos dolores et quas molestias excepturi</li>
                                    <li>Smilique sunt in culpiqui officia deserunt mollitia animi id est laborum</li>
                                </ul>
                                <p>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam, quis nostrum exercitationem mo
                                    sequatu autem vel eum iure veniam quis nostrum exercitationm aleisequatur?
                                    Smilique sunt in culpiqui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harumquid
                                    em rerum facilis est et expedita distinctio. Nam libero tempore cum soluta nobis est eligendioptio cum
                                    que nihil impedit quo minus quod maxime placeat facere possimu.Nemo enim ipsam voluptatem quia
                                    voluptas fugit, sed quia corporisiex.
                                </p>
                            </div>

                            <div className="post_footer">
                                <div className="post_share">
                                    <ul className="share_list">
                                        <li>Share:</li>
                                        <li data-aos="fade-up" data-aos-duration="1000"><a href="#"><i className="ion-social-facebook"></i></a></li>
                                        <li data-aos="fade-up" data-aos-duration="1500"><a href="#"><i className="ion-social-twitter"></i></a></li>
                                        <li data-aos="fade-up" data-aos-duration="2000"><a href="#"><i className="ion-social-dribbble-outline"></i></a></li>
                                        <li data-aos="fade-up" data-aos-duration="2500"><a href="#"><i className="ion-social-instagram-outline"></i></a></li>
                                    </ul>
                                </div>
                                <div className="post_tag">
                                    <ul className="tag_list">
                                        <li data-aos="fade-up" data-aos-duration="2000"><a href="#">#Photography</a></li>
                                        <li data-aos="fade-up" data-aos-duration="1500"><a href="#">#Restaurant</a></li>
                                        <li data-aos="fade-up" data-aos-duration="1000"><a href="#">#Food</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div className="author_div">
                            <div className="author">
                                <img alt="img" src="images/author_sm.png" className="avatar" />
                            </div>
                            <div className="author-block">
                                <h5 className="author_name">Rachel Moor</h5>
                                <p className="author_intro">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore et dolore magna aliqua.
                                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut. Doneco quam felis, ultricies nec, pellentesque preti
                                    um quis ipsumstrud exercitation.</p>
                                <div className="social_media">
                                    <ul className="social_list">
                                        <li data-aos="fade-left" data-aos-duration="1000"><a href="#"><i className="ion-social-facebook"></i></a></li>
                                        <li data-aos="fade-left" data-aos-duration="1500"><a href="#"><i className="ion-social-twitter"></i></a></li>
                                        <li data-aos="fade-left" data-aos-duration="2000"><a href="#"><i className="ion-social-dribbble-outline"></i></a></li>
                                        <li data-aos="fade-left" data-aos-duration="2500"><a href="#"><i className="ion-social-instagram-outline"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="related_posts">
                            <h4 className="widget_title">Similar Posts</h4>
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <article className="blog_post">
                                        <div className="post_img">
                                            <a href="#"><img src="images/blog/xs1.jpg" alt="blog" /></a>
                                        </div>
                                        <div className="post_header">
                                            <h5 className="post_title">
                                                <a href="/blog-details">How We run our coffeshop Business</a>
                                            </h5>
                                        </div>
                                    </article>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <article className="blog_post">
                                        <div className="post_img">
                                            <a href="#"><img src="images/blog/xs2.jpg" alt="blog" /></a>
                                        </div>
                                        <div className="post_header">
                                            <h5 className="post_title">
                                                <a href="/blog-details">How I get my First Michelin Star of My Carrier</a>
                                            </h5>
                                        </div>
                                    </article>
                                </div>

                                <div className="col-lg-4 col-md-4">
                                    <article className="blog_post">
                                        <div className="post_img">
                                            <a href="#"><img src="images/blog/xs3.jpg" alt="blog" /></a>
                                        </div>
                                        <div className="post_header">
                                            <h5 className="post_title">
                                                <a href="/blog-details">We are Introducing Indo Chinese Combo</a>
                                            </h5>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-lg-11">
                                <div className="comments-area">
                                    <h3 className="comments-title">Comments</h3>
                                    <ul className="comment-list">
                                        <li className="comment even thread-even depth-1">
                                            <div className="commenter-block">
                                                <div className="comment-avatar">
                                                    <img alt="img" src="images/blog/commenter1.png" className="avatar" />
                                                </div>
                                                <div className="comment-content">
                                                    <div className="comment-author-name">Indie Rossi <span className="comment-reply"><a href="#" className="comment-reply-link" >Reply <i className="ion-chevron-right"></i><i className="ion-chevron-right"></i></a></span></div>
                                                    <div className="comment-author-comment">
                                                        <p>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam quis nostrum exercitationem mosequatu autem.</p>
                                                    </div>
                                                    <time className="comment-date">August 29, 2022</time>
                                                </div>
                                            </div>

                                            <ul className="children">
                                                <li className="comment even thread-even depth-2">
                                                    <div className="commenter-block">
                                                        <div className="comment-avatar">
                                                            <img alt="img" src="images/blog/commenter2.png" className="avatar" />
                                                        </div>
                                                        <div className="comment-content">
                                                            <div className="comment-author-name">Patricia Doe <span className="comment-reply"><a href="#" className="comment-reply-link" >Reply <i className="ion-chevron-right"></i><i className="ion-chevron-right"></i></a></span></div>
                                                            <div className="comment-author-comment">
                                                                <p>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam quis nostrum exercitationem mosequatu autem.</p>
                                                            </div>
                                                            <time className="comment-date">August 29, 2022</time>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="comment odd thread-odd depth-1">
                                            <div className="commenter-block">
                                                <div className="comment-avatar">
                                                    <img alt="img" src="images/blog/commenter3.png" className="avatar" />
                                                </div>
                                                <div className="comment-content">
                                                    <div className="comment-author-name">Andy Cooper <span className="comment-reply"><a href="#" className="comment-reply-link" >Reply <i className="ion-chevron-right"></i><i className="ion-chevron-right"></i></a></span></div>
                                                    <div className="comment-author-comment">
                                                        <p>Lorem ipsum dolor sit amet, consectetur. Ut enim ad minima veniam quis nostrum exercitationem mosequatu autem.</p>
                                                    </div>
                                                    <time className="comment-date">August 29, 2022</time>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="comments-pagination">
                                        <a className="page-numbers" href="#">1</a>
                                        <span aria-current="page" className="page-numbers current">2</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-11">
                                <div className="comment-respond" data-aos="fade-up" data-aos-duration="1000">
                                    <h3 className="comment-reply-title">Make A Comment</h3>
                                    <form className="comment-form" action="register.php" method="post">
                                        <p className="logged-in-as">Your email address will not be published. Required fields are marked *</p>
                                        <div className="form-container">
                                            <div className="row">
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="form-group">
                                                        <textarea name="message" className="form-control" placeholder="Text Here*" required></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-lg-4">
                                                    <div className="form-group">
                                                        <input type="text" name="name" className="form-control" placeholder="Name*" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-lg-4">
                                                    <div className="form-group">
                                                        <input type="email" name="email" className="form-control" placeholder="E-mail*" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-lg-4">
                                                    <div className="form-group">
                                                        <input type="text" name="phone" className="form-control" placeholder="Phone" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="button_group">
                                                        <input className="button" type="submit" value="Submit" name="submit" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog4;